export default {
    locales: ['sr'],
    messages: {
        'place': 'Место',
        'place-mobile': 'Пласман : {rank}',
        'bib': 'Биб',
        'name': 'Име',
        'hometown': 'Град',
        'bracket': 'Брекет',
        'pace': 'Темпо',
        'chip': 'Чип',
        'time': 'Време',
        'time-mobile': 'Време : {time}',
        'generated_at': 'Генерисано {time}',
        'loading': 'Учитавање',
        'data-load-error': 'Изгледа да је дошло до проблема приликом учитавања резултата.',
        'waiting-results': 'Чекање резултата',
        'error': 'Грешка',
        'gender': 'Пol'
    }
};



// WEBPACK FOOTER //
// ./translate/sr.js